"use strict";

module.exports = {
  OverlappingModel: require('./overlapping-model'),
  SimpleTiledModel: require('./simple-tiled-model')
};